export const READ_CONFIG = '@@config/READ_CONFIG'

export interface ConfigState {
	ENVIRONMENT: string
	API_SERVER: string
	MESSAGING_API_SERVER: string
	MESSAGING_WS_SERVER: string
	LYNXCLOUD_CLIENT: string
	LYNXADMIN_CLIENT: string
	LYNXREMOTE_CLIENT: string
	LYNXACTIVITIES_CLIENT: string
	LYNXVNC_CLIENT: string
	CLUSTER_URL: string
	CLUSTER_URL_HTTP: string
	API_WS_SERVER: string
}

export interface Config {
	ENVIRONMENT: string
	API_SERVER: string
	MESSAGING_API_SERVER: string
	MESSAGING_WS_SERVER: string
	LYNXCLOUD_CLIENT: string
	LYNXADMIN_CLIENT: string
	LYNXREMOTE_CLIENT: string
	LYNXACTIVITIES_CLIENT: string
	LYNXVNC_CLIENT: string
	CLUSTER_URL: string
	CLUSTER_URL_HTTP: string
}

interface ReadConfigAction {
	type: typeof READ_CONFIG
	payload: Config
}

export type ConfigActionTypes = ReadConfigAction
